import type { FilterOptionsState, SxProps, Theme } from "@mui/material";
import React from "react";
import MultiSelect from "./MultiSelect";
import type { SelectOption } from "./MultiSelect.types";

export interface SingleSelectProps {
    options: Array<SelectOption> | undefined;
    customFilterOptions?: (options: SelectOption[], state: FilterOptionsState<SelectOption>) => SelectOption[];
    selectedItem?: string | null;
    onChange: (chosenItem: string | null) => void;
    placeholder?: string;
    label: string;
    disabled?: boolean;
    disableClearable?: boolean;
    isLoading?: boolean;
    toolTipText?: string;
    helperText?: string;
    errorText?: string | JSX.Element;
    noMargin?: boolean;
    paperClassName?: string;
    paperSx?: SxProps<Theme>;
    showHoverOnInputField?: boolean;
    renderOptions?: (option: SelectOption) => JSX.Element;
    additionalIcon?: {
        tooltipText: string;
        icon: JSX.Element;
    };
    warningText?: string | JSX.Element;
    width?: string;
    variant?: "outlined" | "standard";
    noOptionsLabel: string;
    backgroundColor?: "white" | "transparent";
    inputStartAdornment?: JSX.Element;
    clearOnSelect?: boolean;
    focusAndOpen?: boolean;
    alwaysOpenInBottom?: boolean;
    listMaxHeight?: number;
    disableSearch?: boolean;
    onClose?: () => void;
    icon?: JSX.Element;
    onSearchValueChange?: (value: any) => void;
    searchValue?: string;
    onFocus?: () => void;
    onBlur?: () => void;
    children?: React.ReactNode;
}

function SingleSelect(props: SingleSelectProps) {
    const selected: string[] = [];
    if (props.selectedItem) {
        selected.push(props.selectedItem);
    }

    return (
        <MultiSelect
            {...props}
            onChange={(o) => props.onChange(o.length > 0 ? o[0] : null)}
            chosenOptions={selected}
            singleSelect
            paperClassName={props.paperClassName}
            paperSx={props.paperSx}
            noOptionsLabel={props.noOptionsLabel}
            customFilterOptions={props.customFilterOptions}
        />
    );
}

export default SingleSelect;
